// extracted by mini-css-extract-plugin
export default {"TopSongs":"TopSongs_TopSongs__hefw6"};